import { useState, useEffect } from "react";
import { sendEmailVerification } from "firebase/auth";
import { auth } from "../../firebase/config";
// import logoo from "../../assets/images/gymfithorlogo2-removebg-preview.png";
import logoo from "../../assets/images/gymfitorangelogo22.png";
import "./VerifyEmail.css";

import {
  FaEnvelopeOpenText,
  FaShieldAlt,
  FaCheckCircle,
  FaRedoAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";

export default function VerifyEmail() {
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    const savedTime = localStorage.getItem("verificationCooldown");

    if (savedTime) {
      const remaining = Math.floor((savedTime - Date.now()) / 1000);

      if (remaining > 0) {
        setCountdown(remaining);
      }
    }
  }, []);

  useEffect(() => {
    if (countdown <= 0) return;

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  const resendVerification = async () => {
    try {
      await sendEmailVerification(auth.currentUser);

      const nextAllowedTime = Date.now() + 5 * 60 * 1000;

      localStorage.setItem("verificationCooldown", nextAllowedTime);

      setCountdown(300);

      alert("Verification email sent.");
    } catch (error) {
      console.error(error);
      alert("Failed to send verification email.");
    }
  };

  const minutes = Math.floor(countdown / 60);

  const seconds = countdown % 60;

  return (
    <div className="verify-page">
      {/* Left Side */}

      <div className="verify-left">
        <div className="overlay"></div>

        <div className="left-content">
          <FaEnvelopeOpenText className="verify-main-icon" />

          <h1>Verify Your Email</h1>

          <p>
            Secure your Gym Management account before accessing your dashboard.
          </p>

          <div className="verify-features">
            <div>
              <FaCheckCircle />
              Secure Authentication
            </div>

            <div>
              <FaShieldAlt />
              Protect Your Business
            </div>

            <div>
              <FaEnvelopeOpenText />
              One Click Email Verification
            </div>
          </div>
        </div>
      </div>

      {/* Right Side */}

      <div className="verify-right">
        <div className="verify-card">
          <img src={logoo} alt="Logo" className="verify-logo" />

          <h2>Email Verification</h2>

          <p className="verify-text">
            We've sent a verification email to your registered email address.
            Please verify your account before logging in.
          </p>

          <div className="tips">
            <p> Check your Inbox</p>

            <p> Check Spam / Junk Folder</p>
          </div>

          <button onClick={resendVerification} disabled={countdown > 0}>
            <FaRedoAlt />

            {countdown > 0
              ? `Resend in ${minutes}:${seconds.toString().padStart(2, "0")}`
              : "Resend Verification Email"}
          </button>

          <Link className="back-login" to="/login">
            ← Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}
